/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description': 'Ask your team or admin for support.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title': "We couldn't fetch any results for this search"
};